import { history } from "../Layout/Layout";

export const handleAEMReactLink = () => {
  const links = document.querySelectorAll("#root, #notification_banner");

  links.forEach(item => {
    item.querySelectorAll("a.vpd_aem_react_link").forEach(a => {
      const href = a.getAttribute("href");

      a.addEventListener("keydown", e => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          history.push(href);
        }
      });

      a.addEventListener("click", e => {
        e.preventDefault();
        history.push(href);
      });
    });
  });
};
